import { cva } from 'class-variance-authority';

export const cvaRoot = cva([
  'ReviewPreviewStyles-cvaRoot',
  'p-3.2',
  'not-last:mb-1.2',
  'bg-cLightGrey',
  'rounded-[1.6rem]',
]);

export const cvaHeader = cva(['ReviewPreviewStyles-cvaHeader', 'flex justify-between items-center gap-2', 'mb-1.6']);

export const cvaName = cva(['ReviewPreviewStyles-cvaName', 'text-bodyL font-semibold']);

export const cvaText = cva(['ReviewPreviewStyles-cvaText', 'text-bodyL text-cBlack80', 'mb-3.2']);

export const cvaGallery = cva(['ReviewPreviewStyles-cvaGallery', 'grid grid-cols-5 gap-1.2']);

export const cvaGalleryItem = cva([
  'ReviewPreviewStyles-cvaGalleryItem',
  'relative overflow-hidden',
  'aspect-square',
  'rounded-[1.6rem]',
  'cursor-pointer select-none',
]);

export const cvaGalleryItemShowMore = cva([
  'ReviewPreviewStyles-cvaGalleryItemShowMore',
  'flex items-center justify-center',
  'text-titleS text-cBlack48 font-semibold',
  'bg-cDarkGreyOnGrey',
  'rounded-[1.6rem]',
  'cursor-pointer select-none',
]);

export const cvaGalleryItemLabel = cva(
  [
    'ReviewPreviewStyles-cvaGalleryItemLabel',
    'absolute z-[1] bottom-0 left-0',
    'w-full',
    'p-0.2 pb-0.6 px-1',
    'text-center text-labelM font-semibold text-cWhite',
  ],
  {
    variants: {
      type: {
        before: ['bg-cRed'],
        after: ['bg-cMediumGreen'],
      },
    },
  }
);

export const cvaGalleryItemImage = cva(['ReviewPreviewStyles-cvaGalleryItemImage', 'object-center object-cover']);
